import { Skeleton, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";
import PartnersCarousel from "../../reusable/PartnersCarousel";
import { Link as RouterLink } from "react-router-dom";
import PathGrey from "../../images/path-grey.png";

export default function OurExperience({data}){

    return(
        <Box
            sx={{
                background:'url('+PathGrey+')',
                backgroundSize:'cover',
                p:{
                    xs:'6rem 0 3rem 0',
                    md:'25vh 0 3rem 0'
                },
                color:'#19314A',
                textAlign:'center',
            }}
        >
            <Container maxWidth='xl'>
                <Typography variant='h3'
                    sx={{
                        fontSize:'1.6rem',
                        color:'#0B5EAA'
                    }}
                >
                    {data? data.heading : <Skeleton/>}
                </Typography>
                <Typography variant='p' component='p'
                    sx={{
                        m:'2rem 0 -1rem 0',
                        whiteSpace:'break-spaces'
                    }}
                >
                    {data? data.content : <Skeleton/>}
                </Typography>
                <PartnersCarousel
                    loading={!data} 
                />
                <Typography variant='p'
                    component={RouterLink}
                    to={data?.link_url}
                    sx={{
                        color:'#19314A',
                    }}
                >
                    {data? data.link_text : <Skeleton/>}
                </Typography>
            </Container>
        </Box>
    );
}